module.exports = __webpack_public_path__ + "static/img/ico_wechat.92b2eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/ico_wechat.png
// module id = mZFT
// module chunks = 0